<template>
  <div class="change-options-box">
    <div class="change-options" @click="openChangeOptions">
      <i class="far fa-cogs lh-inherit"></i>
      {{ translate('Change Options') }}
    </div>
  </div>
</template>
<script>
import store from './../../mixins/store.mixin'
import currentJob from './../../mixins/current_job.mixin'
import JobManager from "../../manager/JobManager";
import Reconvert from "../../util/Reconvert";
import Analytics from "../../util/Analytics";

export default {
  name: "ChangeOptionsBtn",
  props: {},
  components: {},
  mixins: [
    store,
    currentJob,
  ],
  data() {
    return {
    };
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {
    async openChangeOptions() {
      await Analytics.send('result_action', 'change_options', this.currentJob);

      Reconvert.redoSelected(this.currentJob);
    }
  },
  computed: {}
};
</script>
<style lang="scss">
.change-options-box {
  flex: 1 1 auto;
}
.change-options {
  display: flex;
  background: #F8F9FA;
  border: 1px solid #CBCBCB;
  border-radius: 4px;
  justify-content: start;
  gap:10px;
  padding: 10px 15px;
  align-items: center;
  cursor: pointer;

  .dark-mode & {
    background:#383838;;
    border: 1px solid #595959;
    color: white;
    &:hover {
      background: #323232;
    }
  }

  &:hover {
    background: #F2F2F2;
  }

  .continue-btn-text {
    display: flex;
    gap: 10px;
    align-items: center;
  }
}

.disabled {
  opacity: .5;
  cursor: not-allowed;
}
</style>
